<template>
  <div
    v-if="aiInvoiceData && aiInvoiceData.rows && aiInvoiceData.rows.length > 0"
  >
    <v-card class="mb-4">
      <v-card-title class="bg-light-success d-flex align-center">
        <v-icon left color="success">mdi-file-document</v-icon>
        {{ title || $t("LABELS.AI_INVOICE_ITEMS") }}
        <v-spacer></v-spacer>
        <small class="text-muted">
          {{ $t("FORM_LABELS.INVOICE_NUMBER") }}:
          {{ aiInvoiceData.invoiceNumber }} | {{ $t("FORM_LABELS.DATE") }}:
          {{ aiInvoiceData.date | formatDate }}
        </small>
        <v-btn icon small class="ml-2" @click="toggleClosed">
          <v-icon small>
            {{ closed ? "mdi-chevron-down" : "mdi-chevron-up" }}
          </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text v-show="!closed">
        <v-simple-table dense>
          <template v-slot:default>
            <thead>
              <tr>
                <th>{{ $t("FORM_LABELS.ITEM_NAME") }}</th>
                <th class="text-right">{{ $t("FORM_LABELS.QUANTITY") }}</th>
                <th class="text-right">{{ $t("FORM_LABELS.PRICE") }}</th>
                <th class="text-right">{{ $t("FORM_LABELS.DISCOUNT") }}</th>
                <th class="text-right">{{ $t("FORM_LABELS.TOTAL_PRICE") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in aiInvoiceData.rows" :key="row.id">
                <td>{{ row.itemName }}</td>
                <td class="text-right">{{ row.itemQuantity }}</td>
                <td class="text-right">{{ row.itemPrice }}</td>
                <td class="text-right">
                  {{ row.itemDiscountPercentage || 0 }}%
                </td>
                <td class="text-right">{{ row.itemTotalPrice }}</td>
              </tr>
              <tr class="font-weight-bold bg-light">
                <td colspan="4" class="text-right">
                  {{ $t("LABELS.TOTAL") }}:
                </td>
                <td class="text-right">
                  {{ calculateTotal() }} {{ aiInvoiceData.currency }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AiInvoiceReferenceCard",
  props: {
    aiInvoiceData: {
      type: Object,
      required: true
    },
    title: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      closed: false
    };
  },
  methods: {
    calculateTotal() {
      if (!this.aiInvoiceData || !this.aiInvoiceData.rows) return "0.00";
      return this.aiInvoiceData.rows
        .reduce((sum, row) => sum + parseFloat(row.itemTotalPrice || 0), 0)
        .toFixed(2);
    },
    toggleClosed() {
      this.closed = !this.closed;
    }
  }
};
</script>

<style scoped>
.bg-light-success {
  background-color: #c9f7f5;
}

.bg-light {
  background-color: #f3f6f9;
}
</style>
